export enum Criticality {
  Low = 'LOW',
  High = 'HIGH',
  UnableToAssess = 'UNABLETOASSESS'
}